<div class="section-index">

  <h1 class="workspace-page__title">Dashboard</h1>

  <div class="dashboard-toolbar" *ngIf="configuration as settings">
    <button type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm dashboard-settings-trigger"
            [brMenuTriggerFor]="settingsMenu" [brMenuPosition]="{ x: 'before' }"
            aria-label="Open settings">
      <br-icon>settings</br-icon>
      <span>Settings</span>
      <br-icon class="settings-chevron">expand_more</br-icon>
    </button>

    <ng-template #settingsMenu>
      <br-menu class="dashboard-settings-menu" aria-label="Settings">
        <ng-container *ngIf="settings.stages?.length; else flatSettings">
          <ng-container *ngFor="let stage of settings.stages">
            <div class="settings-menu-heading">{{ stage.title }}</div>
            <button brMenuItem class="settings-menu-item"
                    *ngFor="let item of stage.items" (triggered)="activate(item)" [label]="item.label" [icon]="item.icon"></button>
          </ng-container>
        </ng-container>
        <ng-template #flatSettings>
          <button brMenuItem class="settings-menu-item"
                  *ngFor="let item of settings.items" (triggered)="activate(item)" [label]="item.label" [icon]="item.icon"></button>
        </ng-template>
      </br-menu>
    </ng-template>
  </div>

  <div class="dashboard-panels" *ngIf="groups.length; else emptyState">
    <section #groupPanel class="br-card dashboard-panel" *ngFor="let g of groups"
             [attr.data-group]="g.title" [style.--feature]="g.color">
      <header class="br-card-header dashboard-panel-header">
        <div class="group-badge"><br-icon>{{ g.icon }}</br-icon></div>
        <div class="group-heading">
          <h2 class="br-card-title dashboard-panel-title br-flex br-items-center br-gap-2">
            {{ g.title }}
            <span class="br-badge br-badge--neutral" *ngIf="showSmartWorkflows(g)">BETA</span>
          </h2>
          <p class="dashboard-panel-subtitle">{{ g.description }}</p>
        </div>
        <button type="button" *ngIf="showSmartWorkflows(g); else sectionCount"
                class="br-btn br-btn--outline-secondary br-btn--sm br-ms-auto"
                (click)="activate(g.items[0])">
          <br-icon>settings</br-icon>
          <span>Manage workflows</span>
        </button>
        <ng-template #sectionCount>
          <span class="br-small br-text-muted section-count">
            {{ g.items.length }} {{ g.items.length === 1 ? 'section' : 'sections' }}
          </span>
        </ng-template>
      </header>

      <div class="br-card-body dashboard-panel-body">
        <div class="feature-grid" *ngIf="!showSmartWorkflows(g)">
          <button type="button" class="br-interactive feature-link"
                  *ngFor="let item of g.items" (click)="activate(item)">
            <br-icon class="feature-icon">{{ item.icon }}</br-icon>
            <span class="feature-copy">
              <span class="br-card-title feature-title">{{ item.label }}</span>
              <span class="feature-description">{{ item.description }}</span>
            </span>
          </button>
        </div>

        <section class="smart-workflows" *ngIf="showSmartWorkflows(g)">
          <div class="smart-workflows-state" *ngIf="workflowsLoading">
            Loading workflows...
          </div>
          <div class="smart-workflows-error" *ngIf="workflowsError" role="alert">
            <span>{{ workflowsError }}</span>
            <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
                    (click)="retryPublishedWorkflows()">Retry</button>
          </div>
          <div class="feature-grid smart-workflow-grid"
               *ngIf="!workflowsLoading && !workflowsError">
            <button type="button"
                    class="br-interactive feature-link smart-workflow-card"
                    *ngFor="let workflow of publishedWorkflows"
                    (click)="openWorkflow(workflow)">
              <br-icon class="feature-icon">account_tree</br-icon>
              <span class="feature-copy">
                <span class="br-card-title feature-title">{{ workflow.label }}</span>
                <span class="feature-description">
                  Published {{ workflow.updatedAt | date:'MMM d, y' }}
                </span>
              </span>
            </button>
          </div>
          <div class="smart-workflows-state"
               *ngIf="!workflowsLoading && !workflowsError && !publishedWorkflows.length">
            No published workflows yet.
          </div>
        </section>
      </div>
    </section>
  </div>

  <ng-template #emptyState>
    <div class="empty">No modules are available for your account.</div>
  </ng-template>

</div>
